import React, { useEffect, useState } from 'react'

const QuestInputField = ({
  id,
  className,
  type,
  value,
  name,
  disabled,
  handleBlur,
  handleInputChange,
  setInputFocus,
  isUsedForSearch = false,
  as = 'input',
  rows,
  title,
  placeholder,
}) => {
  const [inputText, setInputText] = useState(value)
  const InputComponent = as === 'textarea' ? 'textarea' : 'input'

  useEffect(() => {
    setInputText(value)
  }, [value])

  const handleChange = (e) => {
    const newValue = e.target.value
    setInputText(newValue)

    if (handleInputChange) {
      handleInputChange(newValue)
    }
  }

  const handleBlurChange = (e) => {
    const { name, value } = e.target
    if (handleBlur) {
      handleBlur(name, value)
    }
    if (isUsedForSearch && setInputFocus) {
      setInputFocus(false)
    }
  }

  const handleFocusChange = () => {
    setInputFocus(true)
  }

  return (
    <InputComponent
      id={id}
      className={className}
      type={as === 'textarea' ? undefined : type}
      value={inputText}
      name={name}
      disabled={disabled}
      rows={as === 'textarea' ? rows : undefined}
      title={title}
      placeholder={placeholder}
      onFocus={setInputFocus ? handleFocusChange : null}
      onBlur={handleBlurChange}
      onChange={handleChange}
    />
  )
}
export default QuestInputField
